import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";

// context
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// components
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import ImageEditer from "bodycodi/cmap/app/components/common/imageEditor/imageEditer";

// utils
import { uploadImg } from "bodycodi/cmap/app/js/common";

type ImageEditorPop = {
  file: any;
  setEditor?: any;
  getData?: any;
  editor?: any;
  returnUrl?: Function;
  handleClose?: any;
};

const ImageEditorPopWrap = ({ file, getData }: ImageEditorPop) => {
  const { seqPartner, seqPartnerCoach } = useSelector((state: RootState) => state.partner);
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [editor, setEditor] = useState<any>({});

  const handleClose = () => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        header: "사진 편집",
        cancleYn: "D",
        redYn: true,
        redButtonLabel: "삭제",
        body: `지금 취소하면 변경 사항이 \n모두 삭제됩니다. \n그래도 삭제할까요?`,
        cancelAlert: () => {
          return;
        },
        closeAlert: () => {
          dispatch({
            type: "POP_UP_OPEN",
            id: "ADD_COMUUNITY_EDITOR",
            open: { addComunityEditor: false },
          });
          editor.stopDrawingMode();
        },
        alert: true,
      },
    });
  };

  const returnUrl = () => {
    const formData: any = new FormData();
    const decodImg = atob(editor.toDataURL().split(",")[1]);
    let array = [];
    for (let i = 0; i < decodImg.length; i++) {
      array.push(decodImg.charCodeAt(i));
    }
    const file = new Blob([new Uint8Array(array)], { type: "image/png" });
    const fileName = "bodycodi_" + new Date().getMilliseconds() + ".png";
    const fileSize = file.size;
    const maxSize = 3 * 1024 * 1024;
    if (fileSize > maxSize) {
      return false;
    }
    formData.append("file", file, fileName);
    formData.append("fileNm", fileName);
    formData.append("seqPartner", seqPartner);
    formData.append("seqPartnerCoach", seqPartnerCoach);

    uploadImg("/community/image/upload", formData, "POST")
      .then((res) => {
        getData(res, fileName);
        dispatch({
          type: "POP_UP_OPEN",
          id: "ADD_COMUUNITY_EDITOR",
          open: { addComunityEditor: false },
        });
      })
      .catch(() => {});
  };

  return (
    <CustomDialog open={state.addComunityEditor} onClose={handleClose} className="image-editor-pop">
      <ImageEditorPop
        file={file}
        setEditor={setEditor}
        editor={editor}
        returnUrl={returnUrl}
        handleClose={handleClose}
      />
    </CustomDialog>
  );
};

const ImageEditorPop = ({ file, setEditor, editor, returnUrl, handleClose }: ImageEditorPop) => {
  return (
    <ImageEditer
      file={file}
      setEditor={setEditor}
      editor={editor}
      returnUrl={returnUrl!}
      handleClose={handleClose!}
      src={{}}
    />
  );
};

export default ImageEditorPopWrap;
